//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ADOindex",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "≥65%" },
        { value: "1", name: "≥36-64%" },
        { value: "2", name: "≤35%" },
      ],
      dataList1: [
        { value: "0", name: "0-1" },
        { value: "1", name: "2" },
        { value: "2", name: "3" },
        { value: "3", name: "4" },
      ],
      dataList2: [
        { value: "0", name: "40-49" },
        { value: "1", name: "50-59" },
        { value: "2", name: "60-69" },
        { value: "3", name: "70-79" },
        { value: "4", name: "80-89" },
        { value: "5", name: "≥90" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ADOindex.vue